import React, { useCallback } from 'react';

import { metadataRoute } from '~/routes'
import CrudLayoutList from '~/containers/CrudLayoutList';
import metadatumSchema from '~/records/schema/metadatumSchema';
import { useDispatch, connect } from 'react-redux';
import { fetchRecords, destroyRecord } from '~/store/modules/metadata';

function List({isLoading, rows, total}) {
  const dispatch = useDispatch();

  const handleFetch = useCallback(
    async (params, requestSource) => {
      dispatch( fetchRecords(params, requestSource) )
    },
    [],
  )

  const onDelete = useCallback(
    async (row) => {
      dispatch( destroyRecord(row.id) )
    },
    []
  )

  return (
    <CrudLayoutList
      breadcrumbs={[{ text: 'Metadados' }]}
      permissionKeyCode="Metadatum"
      routes={{
        newPath:  ()  =>  metadataRoute.new.build(),
        showPath: (id) => metadataRoute.show.build({id}),
        editPath: (id) => metadataRoute.edit.build({id})
      }}
      tableProps={{
        isLoading,
        rows,
        total,
        handleFetch,
        onDelete,
        schema: metadatumSchema,
        actions: ['show', 'edit', 'delete'],
        permissionKeyCode: 'Metadatum',
        filterProps: {
          columns: metadatumSchema.filterColumns
        }
      }}
    />
  );
}

const mapStateToProps = state => ({
  isLoading: state.metadata.listIsLoading,
  rows: state.metadata.data,
  total: state.metadata.totalData,
});

export default connect(mapStateToProps)(List);